import React, { useEffect, useState } from "react";
import Navigation from "../../components/Navigation/Navigation";
import "./languages.css";
import trashIcon from "../../assets/trash.png";
import { languages } from "../../utils/data";
import Select from "react-select";
import { toast } from "react-hot-toast";
import { request } from "../../utils/axios-utils";
import { useParams } from "react-router";
import { ClipLoader } from "react-spinners";
import DeleteModal from "../../components/DeleteModal/DeleteModal";

const Languages = () => {
  const { slug } = useParams();

  const [newLanguage, setNewLanguage] = useState(null);
  const [loading, setLoading] = useState("");
  const [languageList, setLanguageList] = useState([]);
  const [deleteModal, setDeleteModal] = useState({ type: "", id: null });

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      color: "var(--darkOrange)",
      width: "calc(100% - 4px)",
      padding: "2px", // Adjust padding as needed, react-select has its own padding
      border: "1px solid var(--darkOrange)",
      borderRadius: "12px",
      fontSize: "16px",
      boxShadow: "none", // Remove focus shadow
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "var(--darkOrange)",
    }),
    input: (provided) => ({
      ...provided,
      color: "var(--darkOrange)",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "var(--darkOrange)",
    }),
  };

  const addLanguage = async () => {
    if (newLanguage === null) {
      toast.error("Please select additional language.");
      return;
    }

    try {
      setLoading("addLanguage");
      const response = await request({
        url: "/member/add-language",
        method: "POST",
        data: { newLanguage: newLanguage.value, slug },
      });

      setLanguageList((prevData) => {
        return [...prevData, newLanguage.value];
      });

      setNewLanguage(null);

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  const setMainLanguage = async (language) => {
    try {
      setLoading("mainLanguage");

      const response = await request({
        url: "/member/set-main-language",
        method: "POST",
        data: { language, slug },
      });

      setLanguageList(response.data.languages);

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  const removeLanguage = async () => {
    try {
      setLoading("removeLanguage");

      const response = await request({
        url: "/member/remove-language",
        method: "POST",
        data: { language: deleteModal.id, slug },
      });

      setLanguageList(response.data.languages);

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading("");
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading("data");
        const response = await request({
          url: "/member/get-languages",
          method: "POST",
          data: { slug },
        });

        setLanguageList(response.data.languages);
      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setLoading("");
      }
    };

    getData();
  }, []);

  return (
    <Navigation isLoading={loading === "data"}>
      {deleteModal.type === "removeLanguage" && (
        <DeleteModal
          heading={"Remove language?"}
          paragraph={
            "This will remove all translated data from all of yours items and categories."
          }
          btnText={"Remove"}
          setDeleteModal={setDeleteModal}
          deleteFunction={removeLanguage}
        />
      )}

      <h1 className="page-content-h">Manage Languages</h1>
      <p className="page-content-p">
        Manage languages you want to offer on your digital menu.
      </p>

      <div className="languages-container">
        {languageList.map((language, key) => {
          const languageObj = languages.find(
            (lang) => lang?.value === language
          );

          return (
            <div key={key} className="language-bar">
              <h3 className="language-bar-h">{languageObj?.label}</h3>
              <div className="language-helper-div">
                {key === 0 ? (
                  <p className="language-main-p">Main Language</p>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setMainLanguage(language);
                      }}
                      className="language-main-btn"
                    >
                      Set as Main
                    </div>
                    <img
                      onClick={() => {
                        setDeleteModal({
                          type: "removeLanguage",
                          id: language,
                        });
                      }}
                      className="language-trash-img"
                      src={trashIcon}
                    />
                  </>
                )}
              </div>
            </div>
          );
        })}

        <h2 className="add-another-language-h">Add additional language</h2>

        <div className="language-add-bar">
          <Select
            className="custom-select"
            value={newLanguage}
            styles={customSelectStyles}
            options={languages}
            onChange={(selectedOption) => {
              setNewLanguage(selectedOption);
            }}
            placeholder={"Select Language"}
          />

          <div
            onClick={loading === "addLanguage" ? null : addLanguage}
            className="language-add-button"
          >
            {loading === "addLanguage" ? (
              <ClipLoader size={20} color={"#1f120a"} />
            ) : (
              "ADD"
            )}
          </div>
        </div>
      </div>
    </Navigation>
  );
};

export default Languages;
